import { graphqlRequest } from '../graphql/client';
import { LOGIN_USERS_QUERY } from '../graphql/documents';

export interface LoginUserOption {
  email: string;
  displayName: string;
}

interface LoginUsersResponse {
  loginUsers: LoginUserOption[];
}

export async function fetchLoginUsers(): Promise<LoginUserOption[]> {
  const data = await graphqlRequest<LoginUsersResponse>(LOGIN_USERS_QUERY);
  return data.loginUsers;
}
